<mat-dialog-content>
  <p>{{message}}</p>
  
  <form [formGroup]="form" *ngIf="showSelect">
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Seleccionar cadete</mat-label>
      <mat-select formControlName="selectedOption" required>
        <mat-option *ngFor="let option of selectOptions" [value]="option.value">
          {{option.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
  <button mat-raised-button color="primary" (click)="onConfirmClick()" tabindex="1">
    {{confirmButtonText}}
  </button>
  <button *ngIf="showCancelButton" mat-button mat-dialog-close tabindex="-1">
    {{cancelButtonText}}
  </button>
</mat-dialog-actions>
